import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Layouts
import MainLayout from './layouts/MainLayout';
import AdminLayout from './layouts/AdminLayout';

// Pages
import Home from './pages/Home';
import BlogList from './pages/BlogList';
import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import RequestManager from './pages/admin/RequestManager';
import BlogCMS from './pages/admin/BlogCMS';
import ContentEditor from './pages/admin/ContentEditor';

export default function AppRoutes() {
  return (
    <Routes>
      {/* Institucional */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/login" element={<Login />} />
      </Route>

      {/* Administrativo */}
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="requests" element={<RequestManager />} />
        <Route path="blog" element={<BlogCMS />} />
        <Route path="content" element={<ContentEditor />} />
      </Route>
    </Routes>
  );
}
